<mat-dialog-content class="modal-header">
  <h2 mat-dialog-title>CARGAR PROGRAMA PASST</h2>
</mat-dialog-content>
<form #modelForm="ngForm" (ngSubmit)="onSubmit(modelForm)" appIdentityRevealed>
  <mat-dialog-content class="modal-body">
    <div class="block-content">
      <div class="form-horizontal">
        <div class="form-group">
          <label class="col-md-2 control-label">Compañía:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Seleccione: </mat-label>
              <mat-select matSelect [(ngModel)]="model.idCompaniaSelected" name="idCompaniaSelected" #idCompaniaSelected="ngModel" [disabled]="listaCompanias.length == 1"
                (selectionChange)="companiaChanged()" required>
                <mat-option *ngFor="let company of listaCompanias" [value]="company.idCompania">
                  {{ company.nombre }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <label class="col-md-2 control-label">Sede (*):</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>
                Seleccione
              </mat-label>
              <mat-select matSelect [(ngModel)]="model.idSedeSelected" name="idSedeSelected" #idSedeSelected="ngModel"
                required>
                <mat-option *ngFor="let item of listaSedes; index as i" [value]="item.idSede">{{ item.nombre
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-2 control-label">Año:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>
                Año
              </mat-label>
              <mat-select matSelect [(ngModel)]="model.anio" name="idAnioSelected" #idAnioSelected="ngModel" required>
                <mat-option *ngFor="let item of listaAnios; index as i;" [value]='item'>{{item}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <label class="col-md-2 control-label">Tipo Carga:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>
                Tipo Carga
              </mat-label>

              <mat-select matSelect [(ngModel)]="model.idTipoCargaSelected" name="idTipoCargaSelected"
                #idTipoCargaSelected="ngModel" required>
                <!-- <mat-option [value]="0">Seleccione</mat-option> -->
                <mat-option *ngFor="let item of listaTipos; index as i" [value]="item.idParametroDetalle">{{ item.valor
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-2 control-label">Archivo (*):</label>
          <div class="col-md-9">
            <mat-form-field appearance="outline">
              <mat-label>
                Seleccione Archivo
              </mat-label>
              <input matInput type="text" placeholder="Seleccione Archivo" maxlength="40" name="nombreArchivo"
                [(ngModel)]="model.nombreArchivo" disabled>
            </mat-form-field>
          </div>
          <div class="col-md-1">
            <input type="file" class="file-input"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" #fileUpload
              (change)="uploadFile(fileUpload.files)" style="display: none;" />
            <button type="button" mat-icon-button color="primary" aria-label="adjuntar" matTooltip="Adjuntar documento"
              (click)="fileUpload.click()">
              <mat-icon>folder</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="modal-actions">
    <!-- <button type="submit" class="btn btn-naranja" [disabled]="modelForm.invalid" [mat-dialog-close]="model" mat-button cdkFocusInitial>Guardar</button> -->
    <button type="submit" class="btn btn-naranja" mat-button [disabled]="modelForm.invalid">
      Guardar
    </button>
    <button type="button" class="btn btn-celeste" mat-button (click)="onNoClick()">Cancelar</button>
  </mat-dialog-actions>
</form>